import { Navigate, Outlet } from "react-router-dom";
import React, { useEffect, useRef } from "react";
import { useInternet } from "../hooks/useInternet.js";
import { useDispatch, useSelector } from "react-redux";
import { sessionSlice } from "../slices/sessionSlice.jsx";
import { FreeTrialModal } from "./loggedLayout/modals/freetrial/freeTrialModal.jsx";
import { OnboardingModal } from "./loggedLayout/modals/onboarding/onboardingModal.jsx";
import { useMobileDetector } from "../hooks/useMobileDetector.js";

export function LoggedLayout({ children }) {
  let internet = useInternet();
  let dispatch = useDispatch();
  let session = useSelector((state) => state.session);
  let isMobile = useMobileDetector();
  let ref = useRef();

  useEffect(() => {
    // Adjust canvas height to ignore URL bar
    if (isMobile()) {
      ref.current.style.height = window.innerHeight + "px";
    } else {
      ref.current.style.height = "100vh";
    }
    internet.get("/checktoken").then(async (res) => {
      let data = await res.json();
      dispatch(
        sessionSlice.actions.setData({
          ...session,
          user: data.user,
          account: data.account,
          stats: data.stats,
        })
      );
    });
  }, []);

  if (!window.localStorage.token) {
    return <Navigate to={"/auth/login"} />;
  }

  return (
    <div className={"w-screen h-screen bg-blue-50 overflow-auto"} ref={ref}>
      <FreeTrialModal />
      <OnboardingModal />

      {session.user ? (
        <>
          {children}
          <Outlet />
        </>
      ) : (
        <div
          className={"w-full h-full flex items-center justify-center text-5xl"}
        >
          <span className={"fa fa-spinner fa-spin text-blue-200"} />
        </div>
      )}
    </div>
  );
}
